import React from "react";
import {
  Modal as ReactstrapModal,
  Offcanvas as ReactstrapOffcanvas,
} from "reactstrap";

export * from "reactstrap";

const classNames = (...values) => values.filter(Boolean).join(" ");

/** Application standard for dialog overlays. */
export const AppModal = ({ className, modalClassName, ...props }) => (
  <ReactstrapModal
    {...props}
    className={classNames("app-modal", className)}
    modalClassName={classNames("app-modal__dialog", modalClassName)}
    unmountOnClose={props.unmountOnClose ?? true}
    returnFocusAfterClose={props.returnFocusAfterClose ?? true}
  />
);

/** Application standard for side-panel overlays. */
export const AppOffcanvas = ({
  className,
  offcanvasClassName,
  onClosed,
  ...props
}) => {
  const handleClosed = (...args) => {
    onClosed?.(...args);

    // Reactstrap Offcanvas clears document.body's overflow as it closes. When
    // the drawer is nested inside another drawer or a modal, that
    // inadvertently releases the parent overlay's scroll lock and exposes a
    // second page scrollbar.
    if (typeof window !== "undefined") {
      window.requestAnimationFrame(() => {
        const hasOpenModal = Boolean(document.querySelector(".modal.show"));
        const hasOpenParentOverlay =
          hasOpenModal || Boolean(document.querySelector(".offcanvas.show"));
        if (hasOpenParentOverlay) {
          if (hasOpenModal) document.body.classList.add("modal-open");
          document.body.style.overflow = "hidden";
        }
      });
    }
  };

  return (
    <ReactstrapOffcanvas
      {...props}
      className={classNames(
        "app-offcanvas",
        "app-offcanvas__dialog",
        className,
        offcanvasClassName
      )}
      onClosed={handleClosed}
      unmountOnClose={props.unmountOnClose ?? true}
      returnFocusAfterClose={props.returnFocusAfterClose ?? true}
    />
  );
};

export { AppModal as Modal, AppOffcanvas as Offcanvas };
